import { render } from "./defaultPage.vue?vue&type=template&id=64fb0298&scoped=true"
import script from "./defaultPage.vue?vue&type=script&lang=js"
export * from "./defaultPage.vue?vue&type=script&lang=js"

import "./defaultPage.vue?vue&type=style&index=0&id=64fb0298&lang=scss&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fb0298"]])

export default __exports__